var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padded"},[_c('tickets-table',{attrs:{"site-id":_vm.rowData.site_id,"asset-id":_vm.assetId,"owner-id":_vm.rowData.organisation_id,"process-key":"equip-ticket","hide-site":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }